export default "__VITE_ASSET__BGheDu8k__"